import styles from 'pages/gallery/gallery.module.css';
import generalStyles from 'index.module.css';
import { Element } from 'react-scroll';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useGetVideosInfo,
    useGetVideosInfo2,
    useGetVideosInfo3,
    useGetVideosInfo4,
} from 'pages/gallery/gallery.hooks';
import { PicsGallery } from 'sections/gallery/PicsGallery';
import FullscreenPlayer from 'components/fullscreenPlayer/FullscreenPlayer';

export const Gallery = () => {
    const { t } = useTranslation();
    const videosInfo = useGetVideosInfo();
    const videoInfo2 = useGetVideosInfo2();
    const videoInfo3 = useGetVideosInfo3();
    const videoInfo4 = useGetVideosInfo4();

    const [isImgLoaded, setIsImgLoaded] = useState(false);
    const handleImageLoad = () => {
        setIsImgLoaded(true);
    };

    return (
        <section
            id="section-gallery"
            className={`${generalStyles.heightAuto} ${styles.gallerySection}`}
        >
            <Element name="gallery">
                <div className={generalStyles.container}>
                    <div className={styles.media}>
                        <div className={styles.videos}>
                            <h1 className={styles.videos__title}>
                                {t('gallery.ourVideos')}
                            </h1>
                            <ul className={styles.videos__list}>
                                {videosInfo.map(
                                    (
                                        { url, title, thumbnailSrc, id },
                                        index
                                    ) => {
                                        return (
                                            <li
                                                className={styles.videos__item}
                                                key={`${title}-${index}`}
                                            >
                                                {!isImgLoaded && (
                                                    <div
                                                        className={
                                                            styles.item__imgLoading
                                                        }
                                                    ></div>
                                                )}
                                                <FullscreenPlayer
                                                    playerId={id}
                                                    videoUrl={url}
                                                    imageUrl={thumbnailSrc}
                                                    handleImageLoad={
                                                        handleImageLoad
                                                    }
                                                    isImgLoaded={isImgLoaded}
                                                />
                                                <h2
                                                    className={
                                                        styles.item__title
                                                    }
                                                >
                                                    {title}
                                                </h2>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>

                            <ul className={styles.videos__list}>
                                {videoInfo2.map(
                                    (
                                        { url, title, thumbnailSrc, id },
                                        index
                                    ) => {
                                        return (
                                            <li
                                                className={styles.videos__item}
                                                key={`${title}-${index}`}
                                            >
                                                {!isImgLoaded && (
                                                    <div
                                                        className={
                                                            styles.item__imgLoading
                                                        }
                                                    ></div>
                                                )}
                                                <FullscreenPlayer
                                                    playerId={id}
                                                    videoUrl={url}
                                                    imageUrl={thumbnailSrc}
                                                    handleImageLoad={
                                                        handleImageLoad
                                                    }
                                                    isImgLoaded={isImgLoaded}
                                                />
                                                <h2
                                                    className={
                                                        styles.item__title
                                                    }
                                                >
                                                    {title}
                                                </h2>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>

                            <ul className={styles.videos__list}>
                                {videoInfo3.map(
                                    (
                                        { url, title, thumbnailSrc, id },
                                        index
                                    ) => {
                                        return (
                                            <li
                                                className={styles.videos__item}
                                                key={`${title}-${index}`}
                                            >
                                                {!isImgLoaded && (
                                                    <div
                                                        className={
                                                            styles.item__imgLoading
                                                        }
                                                    ></div>
                                                )}
                                                <FullscreenPlayer
                                                    playerId={id}
                                                    videoUrl={url}
                                                    imageUrl={thumbnailSrc}
                                                    handleImageLoad={
                                                        handleImageLoad
                                                    }
                                                    isImgLoaded={isImgLoaded}
                                                />
                                                <h2
                                                    className={
                                                        styles.item__title
                                                    }
                                                >
                                                    {title}
                                                </h2>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>

                            <ul className={styles.videos__list}>
                                {videoInfo4.map(
                                    (
                                        { url, title, thumbnailSrc, id },
                                        index
                                    ) => {
                                        return (
                                            <li
                                                className={styles.videos__item}
                                                key={`${title}-${index}`}
                                            >
                                                {!isImgLoaded && (
                                                    <div
                                                        className={
                                                            styles.item__imgLoading
                                                        }
                                                    ></div>
                                                )}
                                                <FullscreenPlayer
                                                    playerId={id}
                                                    videoUrl={url}
                                                    imageUrl={thumbnailSrc}
                                                    handleImageLoad={
                                                        handleImageLoad
                                                    }
                                                    isImgLoaded={isImgLoaded}
                                                />
                                                <h2
                                                    className={
                                                        styles.item__title
                                                    }
                                                >
                                                    {title}
                                                </h2>
                                            </li>
                                        );
                                    }
                                )}
                            </ul>
                        </div>
                        <div className={styles.photos}>
                            <h1 className={styles.photos__title}>
                                {t('gallery.ourPhotos')}
                            </h1>
                            <PicsGallery />
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
